// Mapping katalog (CVH/HAK) kodova → marketplace dropdown vrijednosti.
// Katalog šalje 1-slovne ili kratke kodove (kao u `VehicleTypeLabels.cs` na
// BE-u: A/M/S, F/R/A/X, B/P/D/E/H/LPG/CNG). Marketplace forma očekuje pune
// stringove iz `services/api/sales/listings/consts` (manual/automatic/semi, fwd/rwd/awd,
// petrol/diesel/electric/...). Bez ovog mapinga dropdowni imaju vrijednost
// u stateu ali se vizualno ne odabire opcija.

const lower = (v: string | null | undefined) =>
  v == null ? "" : v.trim().toLowerCase();

// === FUEL ===
// Katalog: B/P=Benzin, D=Diesel, E=Električni, H=Hibrid, LPG, CNG
export const mapFuelTypeCode = (code: string | null | undefined): string => {
  const c = lower(code);
  if (!c) return "";
  if (c === "b" || c === "p" || c === "petrol" || c === "benzin") return "petrol";
  if (c === "d" || c === "diesel" || c === "dizel") return "diesel";
  if (c === "e" || c === "electric" || c === "električni") return "electric";
  if (c === "h" || c === "hybrid_petrol" || c === "hybrid") return "hybrid_petrol";
  if (c === "lpg") return "lpg";
  if (c === "cng") return "cng";
  return "";
};

// === TRANSMISSION ===
// Katalog: A=Automatski, M=Manualni, S=Sekvencijalni
export const mapTransmissionCode = (code: string | null | undefined): string => {
  const c = lower(code);
  if (!c) return "";
  if (c === "m" || c === "manual" || c === "manualni" || c === "ručni") return "manual";
  if (c === "a" || c === "automatic" || c === "automatski") return "automatic";
  if (c === "s" || c === "semi" || c === "sekvencijalni" || c === "poluautomatski") return "semi";
  return "";
};

// === DRIVE / DRIVEN WHEELS ===
// Katalog: F=Prednji, R=Stražnji, A/X=4x4
export const mapDriveTypeCode = (code: string | null | undefined): string => {
  const c = lower(code);
  if (!c) return "";
  if (c === "f" || c === "fwd" || c === "prednji") return "fwd";
  if (c === "r" || c === "rwd" || c === "stražnji") return "rwd";
  if (c === "a" || c === "x" || c === "awd" || c === "4x4" || c === "4") return "awd";
  return "";
};

// === BODY SHAPE ===
// CVH `OblikKaroserijeOznaka` koristi hrvatske kratice; istovremeno katalog
// `VehicleType.BodyCode` može doći iz starog seed-a. Pokrivamo najčešće
// varijante uključujući naziv-based fallback (npr. "Limuzina", "SUV").
export const mapBodyShapeCode = (code: string | null | undefined): string => {
  const c = lower(code);
  if (!c) return "";
  // Marketplace native vrijednosti — već ispravne, prolaze direktno.
  if (["limousine", "hatchback", "karavan", "suv", "coupe", "cabrio", "van", "pickup"].includes(c)) return c;
  // Hrvatski / katalog nazivi i kratice.
  if (c === "lm" || c.startsWith("limuz")) return "limousine";
  if (c === "hb" || c.includes("hatch")) return "hatchback";
  if (c === "kr" || c.includes("karavan") || c === "estate" || c === "wagon") return "karavan";
  if (c === "te" || c === "suv" || c.includes("terenac") || c.includes("sport utility")) return "suv";
  if (c === "kp" || c.includes("coupe") || c.includes("kupe")) return "coupe";
  if (c === "ka" || c.includes("cabrio") || c.includes("kabriolet") || c.includes("roadster")) return "cabrio";
  if (c === "vn" || c === "van" || c.includes("minivan") || c.includes("mpv")) return "van";
  if (c === "pi" || c === "pu" || c.includes("pick")) return "pickup";
  return "";
};
